import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import * as i18n from "util/i18n";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { actions as debinActions } from "reducers/debin";
import EmitDebinSummaryBody from "./components/Summary";

const EmitDebinSummaryPage = () => {
    const { debinPrestacion, debinTicket, seller } = useSelector((state) => state.debin);
    useConfirmTransaction(debinPrestacion, debinTicket, "debin/emit");
    const data = {
        seller: seller?.cuit,
        cbu: debinPrestacion?.selectedAccount?.cbu,
        prestacion: debinPrestacion?.service,
        concept: debinPrestacion?.concept,
        reference: debinPrestacion?.reference,
        description: debinPrestacion?.description,
        currency: debinPrestacion?.selectedAccount?.currency,
        beneficiary: debinPrestacion?.beneficiary?.document || debinPrestacion?.beneficiary,
        beneficiaryName: debinPrestacion?.beneficiary?.headline || debinPrestacion?.beneficiaryName,
        service: debinPrestacion?.service,
        accountInfo: debinPrestacion?.selectedAccount?.shortLabel,
        productId: debinPrestacion?.productId,
        operationType: "activar",
        idTransaction: debinPrestacion?.idTransaction,
    };
    return (
        <>
            <Notification scopeToShow="/debinPayments/AddRecurence" />
            <ResponsiveHeader id="debin.emit" />
            <MainContainer className="afip-payment-details-list">
                <div className="container">
                    <h2 className="text-lead afip-title-detail">{i18n.get("debin.summary.confirm")}</h2>
                    <div className="ticket grid-table form-summary">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <EmitDebinSummaryBody
                                accountInfo={debinPrestacion?.selectedAccount?.shortLabel}
                                beneficiary={data?.beneficiary}
                                beneficiaryName={data?.beneficiaryName}
                                productId={debinPrestacion?.productId}
                                service={debinPrestacion?.service}
                                reference={debinPrestacion?.reference}
                                concept={debinPrestacion?.concept}
                                description={debinPrestacion?.description}
                            />
                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>

                    <GeneralCredentialForm
                        transactionData={data}
                        action={debinActions.relateBuyerToRecurrency}
                        idActivity="load.debin.recurrency"
                        hideIndications
                        actionOnReload={debinActions.setBeneficiary}
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default EmitDebinSummaryPage;
